import React, { useState, forwardRef } from 'react';
import PropTypes from 'prop-types';
import {
  Slide,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  TextField,
  Box,
} from '@mui/material';
import Iconify from './iconify.component';

const Transition = forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const ConfirmPopup = ({
  title,
  message,
  noteText,
  onCancel,
  onSuccess,
  successButtonText,
  cancelButtonText,
  showConfirmationInput,
  confirmationInputText,
  autofillConfirmation,
  infoText,
}) => {
  const [processing, setProcessing] = useState(false);
  const [confirmationText, setConfirmationText] = useState(
    autofillConfirmation ? confirmationInputText : ''
  );

  const handleApiCall = () => {
    setProcessing(true);
    onSuccess();
  };

  return (
    <Dialog
      open
      onClose={() => {
        if (!processing) {
          onCancel();
        }
      }}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      fullWidth
      TransitionComponent={Transition}
    >
      <DialogTitle
        id="confirm-dialog-title"
        sx={{ display: 'flex', alignItems: 'center' }}
      >
        <Iconify icon="ic:warning" width={24} sx={{ color: 'red', mr: 1 }} />{' '}
        {title}
      </DialogTitle>
      <DialogContent id="confirm-dialog-description">
        {message}
        {infoText?.version && (
          <>
            <br />
            <br />
            <Typography>
              <strong>Version:</strong> {infoText.version}
            </Typography>
            <Typography>
              <strong>Relase Note:</strong> {infoText.releaseNotes}
            </Typography>
          </>
        )}
        {noteText && (
          <>
            <br />
            <br />
            <Typography>
              <strong>Note:</strong> {noteText}
            </Typography>
          </>
        )}

        {showConfirmationInput && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" color="secondary" sx={{ mb: 1 }}>
              Please enter{' '}
              <b>
                <i>{confirmationInputText}</i>
              </b>{' '}
              to proceed:
            </Typography>
            <TextField
              label=""
              type="text"
              onChange={(e) => setConfirmationText(e.target.value)}
              value={confirmationText}
              fullWidth
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', marginBottom: 2 }}>
        <Button
          color="error"
          variant="contained"
          onClick={() => handleApiCall()}
          disabled={
            processing ||
            (showConfirmationInput &&
              confirmationText !== confirmationInputText)
          }
        >
          {processing && <Iconify icon="line-md:loading-loop" sx={{ mr: 1 }} />}
          {successButtonText}
        </Button>
        &nbsp;&nbsp;
        <Button
          color="secondary"
          variant="contained"
          onClick={onCancel}
          disabled={processing}
        >
          {cancelButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmPopup.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  noteText: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  successButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  showConfirmationInput: PropTypes.bool,
  confirmationInputText: PropTypes.string,
  autofillConfirmation: PropTypes.bool,
  infoText: PropTypes.objectOf,
};
ConfirmPopup.defaultProps = {
  noteText: '',
  successButtonText: 'Yes',
  cancelButtonText: 'No',
  showConfirmationInput: false,
  confirmationInputText: '',
  autofillConfirmation: false,
  infoText: {},
};

export default ConfirmPopup;
